import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { MatSelect, MatSelectChange } from '@angular/material/select';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { Network } from 'src/app/shared/model/network';
import { environment } from 'src/environments/environment';
import { NetworkService } from '../service/network.service';

@Component({
    selector: 'app-network-list',
    templateUrl: './network-list.component.html',
    styleUrls: ['./network-list.component.scss']
})
export class NetworkListComponent {

    @Input()
    networks$: Observable<Network[]>;

    @Input()
    loadingNetworks: boolean;

    @Input()
    style: any;

    @Input()
    activateStyle: any;

    @Input()
    deactivateStyle: any;

    @Output()
    public clickNetwork = new EventEmitter<string>();

    @Input() showActiveOnly: boolean = true;


    logoUrl: string;

    isNetworksPage: boolean = false;

    networkSelected: boolean = false;

    selectedNetwork: any;
    isAncinePage: boolean;

    @ViewChild(MatSelect) selectRef: MatSelect;

    constructor(private router: Router,
        private networkService: NetworkService) {
        this.logoUrl = environment.bucketUrlImagesNetworks;

        // Verifica la URL inicial
        this.isNetworksPage = this.router.url.includes('epg/networks');
        this.isAncinePage = this.router.url.includes('ancine'); 

        // Detectar cambios en la URL
        this.router.events.subscribe(() => {
            this.isNetworksPage = this.router.url.includes('epg/networks');
            this.isAncinePage = this.router.url.includes('ancine'); 

        });
     
    }


    onNetworkSelected(event: MatSelectChange): void {
        this.clickNetwork.emit(event.value);
        this.selectedNetwork = event.value;
    }

    selectNetwork(network: Network) { 
        this.selectedNetwork = network;
    }

    clearSelectedNetwork() {
        this.clickNetwork.emit(null);
        if (this.selectRef) {
          this.selectRef.value = null; 
        }
      }

}
